import PartnerApprovalTable from "./components/PartnerApprovalTable";

const Tables = () => {
  return (
    <div>
      <div className="f mt-5 h-full w-full">
        <PartnerApprovalTable />
      </div>
    </div>
  );
};

export default Tables;
